import React from 'react';

export const HalfboardIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 2 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width={width} height={height} rx="12" fill="white" />
        <path
          d="M9.498 8.2H10.898V18H9.498V8.2ZM3.87 18H2.47V8.2H3.87V18ZM9.624 13.632H3.73V12.414H9.624V13.632ZM14.2513 18V8.2H18.6473C19.7767 8.2 20.6447 8.42867 21.2513 8.886C21.858 9.334 22.1613 9.95 22.1613 10.734C22.1613 11.266 22.04 11.714 21.7973 12.078C21.564 12.442 21.2467 12.722 20.8453 12.918C20.444 13.114 20.01 13.212 19.5433 13.212L19.7953 12.792C20.3553 12.792 20.85 12.89 21.2793 13.086C21.7087 13.282 22.0493 13.5713 22.3013 13.954C22.5533 14.3273 22.6793 14.794 22.6793 15.354C22.6793 16.194 22.362 16.8473 21.7273 17.314C21.102 17.7713 20.1687 18 18.9273 18H14.2513ZM15.6513 16.866H18.8713C19.646 16.866 20.2387 16.7353 20.6493 16.474C21.06 16.2127 21.2653 15.802 21.2653 15.242C21.2653 14.6727 21.06 14.2573 20.6493 13.996C20.2387 13.7347 19.646 13.604 18.8713 13.604H15.5253V12.47H18.5213C19.2307 12.47 19.7813 12.3393 20.1733 12.078C20.5653 11.8167 20.7613 11.4247 20.7613 10.902C20.7613 10.3793 20.5653 9.98733 20.1733 9.726C19.7813 9.46467 19.2307 9.334 18.5213 9.334H15.6513V16.866Z"
          fill={fill}
        />
      </svg>
    </div>
  );
};
